module.exports = __webpack_public_path__ + "static/media/nyc-wallpaper-wp60010530.c77b79ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nyc-wallpaper-wp60010530.jpg
// module id = 71
// module chunks = 0